<template>
  <div class="expense-form">
    <img src="@/assets/logo.png" alt="Logo" class="form-logo">
    <h1>Gastos con soporte</h1>
    <form >

      <div class="form-group">
        <label for="maestroGasto">Maestro Gasto*</label>
        <v-select :options="maestroGasto" v-model="expense.maestroGasto" label="nombreviaje" :reduce="gasto => gasto.id" @search="onGastoSearch" required @submit.prevent="submitExpense"/>
      </div>

          <div class="tabs">
            <button :class="{ active: activeTab === 1 }" @click.prevent="activeNewTab">Detalles de Gastos</button>
            <button :class="{ active: activeTab === 2 }" @click.prevent="activeEditTab">Gastos Enviados</button>
          </div>


        <!-- Contenido de la pestaña 2 -->
        <div v-if="activeTab === 2">
          <div class="summary">
            <p>Gastos pendientes: {{ totalSpentEdits }}</p>
            <button type="button" @click="sendEdit">Enviar cambios</button>
          </div>
          
          <div v-for="(gasto, index) in gastossubidos" :key="index" class="gasto-group">
            
            <h3 @click="toggleCollapseEdit(index)">
              <CircleAlert v-if="gasto.edit" class="icon-edit-true" />
              <Check v-else class="icon-edit-false" />
              Gasto enviado {{ index + 1 }}
              <Plus v-if="gasto.collapsed" class="icon-collapsed" />
              <Minus v-else class="icon-collapsed" />
            </h3>
            
            <div class="buttons">
              <button type="button" @click="saveEdit(index)">Guardar cambios en Gasto {{ index + 1 }}
              </button>
            </div>
            
            <div v-if="!gasto.collapsed">
              <div class="form-group date-input-container">
                <label for="fechagasto">Fecha del Gasto*</label>
                <input type="date" v-model="gasto.fechagasto" required />
                <span class="icon">📅</span>
              </div>
              <div class="form-group">
                <label for="ciudad">Ciudad*</label>
                <v-select :options="ciudades" v-model="gasto.ciudad" label="nombreMunicipio"  required @search="onCiudadSearch"/>
              </div>
              <div class="form-group">
                <label for="proveedores">Proveedor*</label>
                <v-select :options="proveedores" v-model="gasto.proveedor" required label="nombreProveedor" @search="onProveedorSearch"/>
              </div>
              <div class="form-group">
                <label for="concepto">Concepto*</label>
                <v-select :options="conceptos" v-model="gasto.concepto" required label="descripcion" @search="onConceptoSearch"/>
              </div>
              <div v-if="mostrarCamposAdicionalesEdit(gasto)">
                <div class="form-group">
                  <label for="clientCode">Cliente*</label>
                  <v-select :options="clientCodes" v-model="gasto.cliente" required label="name" @search="onClientCodesSearch"/>
                </div>
                <div class="form-group">
                  <label for="amountOfPeople">Cantidad de personas*</label>
                  <input type="number" v-model="gasto.amountofpeople" required />
                </div>
              </div>
              <div class="form-group">
                <label for="moneda">Moneda*</label>
                <v-select :options="monedas" v-model="gasto.moneda" required label="nombreMoneda" @search="onCurrencySearch"/>
              </div>
              <div class="form-group">
                <label for="mediopago">Medio de Pago*</label>
                <v-select :options="mediosPago" v-model="gasto.mediopago" label="nombre" required @search="onPaymentMeansSearch"/>
              </div>
              <div class="form-group">
                <label for="valor">Valor*</label>
                <input type="number" v-model="gasto.valor" step="0.01" required />
              </div>
              <div class="form-group">
                <label for="observaciones">Observaciones</label>
                <textarea v-model="gasto.observaciones"></textarea>
              </div>
              <div class="form-group" v-if="gasto.urlanexo">
                <div v-for="(url, index) in gasto.urlanexo" :key="index">
                  <a :href="url" target="_blank">Adjunto {{ index + 1 }} </a>
                </div>
                
              </div>
            </div>
          </div>
        </div>
          
        <div v-if="activeTab === 1">
            <div v-for="(gasto, index) in expense.gastos" :key="index" class="gasto-group">
              
            <h3 @click="toggleCollapse(index)" class="toggle-header">
              Detalle gasto {{ index + 1 }}
              <Plus v-if="gasto.collapsed" class="icon-collapsed" />
              <Minus v-else class="icon-collapsed" />
            </h3>
            <div class="buttons">
              <button class="fixed-button" type="button" @click="removeGasto(index)">Eliminar Gasto</button>
            </div>
            
            <div v-if="!gasto.collapsed" class="form-container">
              <div class="form-group date-input-container">
                <label for="fechagasto">Fecha del Gasto*</label>
                <input type="date" v-model="gasto.fechagasto" required />
                <span class="icon">📅</span>
              </div>
              <div class="form-group">
                <label for="ciudad">Ciudad*</label>
                <v-select :options="ciudades" v-model="gasto.ciudad"  label="nombreMunicipio" required :reduce="ciudad => ciudad.id" @search="onCiudadSearch"/>
              </div>
              <div class="form-group">
                <label for="proveedores">Proveedor*</label>
                <v-select :options="proveedores" v-model="gasto.proveedor" required label="nombreProveedor" :reduce="proveedor => proveedor.id" @search="onProveedorSearch"/>
              </div>
              <div class="form-group">
                <label for="concepto">Concepto*</label>
                <v-select :options="conceptos" v-model="expense.gastos[index].concepto" required label="descripcion" :reduce="concepto => concepto.id" @search="onConceptoSearch"/>
              </div>
              <div v-if="mostrarCamposAdicionales(gasto)">
                <div class="form-group">
                  <label for="clientCode">Cliente*</label>
                  <v-select :options="clientCodes" v-model="gasto.clientcode" required label="name" :reduce="code => code.id" @search="onClientCodesSearch"/>
                </div>
                <div class="form-group">
                  <label for="amountOfPeople">Cantidad de personas*</label>
                  <input type="number" v-model="gasto.amountofpeople" required />
                </div>
              </div>
              <div class="form-group">
                <label for="moneda">Moneda*</label>
                <v-select :options="monedas" v-model="expense.gastos[index].moneda" required label="nombreMoneda" :reduce="moneda => moneda.id" @search="onCurrencySearch"/>
              </div>
              <div class="form-group">
                <label for="mediopago">Medio de Pago*</label>
                <v-select :options="mediosPago" v-model="expense.gastos[index].mediopago" label="nombre" required @search="onPaymentMeansSearch"/>
              </div>
              <div class="form-group">
                <label for="valor">Valor*</label>
                <input type="number" v-model="gasto.valor" step="0.01" required />
              </div>
              <div class="form-group">
                <label for="observaciones">Observaciones</label>
                <textarea v-model="gasto.observaciones"></textarea>
              </div>
              <div class="form-group">
                <file-pond name="file" :files="expense.gastos[index].myFiles" label-idle="Examina para seleccionar archivo" :allowBrowse="true" :allow-multiple="true" :max-file-size="'10MB'" :required=false accepted-file-types="image/*,application/pdf" :attributes="{ capture: 'environment' }" @addfile="(error, fileItems) => uploadFile(index, fileItems)" @removefile="(fileItems) => handleRemoveFile(index, fileItems)" @addfilestart="onAddFileStart"
                @processfile="onProcessFile"></file-pond>
                <p v-if="expense.gastos[index].isUploading">📤 Procesando archivo...</p>
              </div>
            </div>
            
            <hr />
            
        </div>
        <div class="buttons">
            <button type="button" @click="addGasto">Agregar detalle al gasto</button>
            <button type="submit" @click.prevent="submitExpense">Subir gastos</button>
          </div>
      </div>

    </form>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import {updateGCS1, tokenValidation, insertarDetalleGCS, selectProveedores, selectDepartamentos, selectConceptos, selectMaestroGastos, uploadToOneDr, selectMonedas, selectMediosPago, selectClientCodes, selectSpentDetailEdit, editSpents} from '@/api/api';
import { Plus, Minus, Check, CircleAlert } from 'lucide-vue-next'; "lucide-vue-next";

import vueFilePond from 'vue-filepond';
// Import plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginPdfPreview from "filepond-plugin-pdf-preview";

// Import styles
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import "filepond-plugin-pdf-preview/dist/filepond-plugin-pdf-preview.min.css";
import imageCompression from 'browser-image-compression';


// Create FilePond component
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview, FilePondPluginFileValidateSize, FilePondPluginPdfPreview);

export default {
  components: {
    vSelect,
    FilePond,
    Plus,
    Minus,
    Check,
    CircleAlert,
  },
  data() {
    return {
      tableType: 'gcs',
      activeTab: 1,
      expense: {
        gastos: [],
        maestroGasto: null,
      },
      maestroGasto: [],
      nombregasto: '',
      ciudades: [],
      proveedores: [],
      conceptos: [],
      clientCodes: [],
      monedas: [],
      totalCOP: 0,
      totalUSD: 0,
      mediosPago: [],
      correousuario: '',
      gastossubidos: [],
      spentsedits: [],
      fileUploading: false,
      uploading: false,
    };
  },
  mounted() {
    this.reloadPage();
    this.fetchProveedores();
    this.fetchCiudades();
    this.fecthConceptos();
    this.fecthClientCodes();
    this.fecthGastos();
    this.fecthCurrency();
    this.fecthPaymentMeans();
  },
  created() {
    this.fetchCiudades();
  },
  watch: {
    'expense.maestroGasto'() {

      this.fecthExpenses();
    }
  },
  computed: {
    totalSpentEdits() {
      return this.spentsedits.length;
    },
  }, 
  methods: {
      saveEdit(index) {
      const gastoEditado = this.gastossubidos[index];

      // Verificar si el gasto ya está en la lista de editados
      if (this.spentsedits.length == 0) {
        this.spentsedits.push({ ...gastoEditado });
        this.gastossubidos[index].edit = true;
      } else { 
        let duplicated = false;
        for (let i = 0; i < this.spentsedits.length; i++) {
          if (this.spentsedits[i].iddetallegasto === gastoEditado.iddetallegasto) {
            this.spentsedits[i] = gastoEditado;
            duplicated = true;
            this.gastossubidos[index].edit = true;
            break;
          }
        }
        if (!duplicated) {
          this.spentsedits.push({ ...gastoEditado });
          this.gastossubidos[index].edit = true;
        }
      }
    },
    async sendEdit() {
      if (this.spentsedits.length == 0) {
        alert("No hay gastos para actualizar");
      } else if (this.checkRequiredEditFields()) {
        alert("Datos en blanco, revisar.")
      } else {
        let dateTimeActual = new Date(Date.now());
        dateTimeActual.setHours(dateTimeActual.getHours() - 5);
        let data = []
        for (const gasto of this.spentsedits) {
          data.push({
            ...gasto,
            fechaactualizacion: dateTimeActual.toISOString(),
          })
        }
        let tableType = this.tableType;
        await editSpents(data, tableType);
        alert("Gastos actualizados");
        this.spentsedits = [];
        this.fecthExpenses();
      }
    },
    async fecthExpenses() {
      try {
        const info = {id: this.expense.maestroGasto, tableType: this.tableType};
        const response = await selectSpentDetailEdit(info);
        this.gastossubidos = response.data.map(gasto => gasto);
      } catch (error) {
        alert("Error al buscar gastos")
      }
    },
    activeNewTab() {
      this.activeTab = 1;
    },
    activeEditTab() {
      this.activeTab = 2;
    },
    mostrarCamposAdicionales(gasto) {
      return gasto.concepto === 7; // Valor que represente "Gasto de representacion"
    },
    mostrarCamposAdicionalesEdit(gasto) {
      if (!gasto.concepto) {
        return false;
      } else {
        return gasto.concepto.id === 7; // Valor que represente "Gasto de representacion"
      }
    },
    calcularTotalesPorMoneda() {
      // Resetear totales antes de sumar
      this.totalCOP = 0;
      this.totalUSD = 0;

      // Calcular totales según tipo de moneda
      this.expense.gastos.forEach(gasto => {
        if (gasto.moneda === 1) {
          this.totalCOP += parseFloat(gasto.valor || 0);
        } else if (gasto.moneda === 2) {
          this.totalUSD += parseFloat(gasto.valor || 0);
        }
      });
    },
    async reloadPage() { // Recarga la pagina en caso de que el token haya caducado
      let ValidToken = await tokenValidation();
      try {
        if(ValidToken.data == undefined || ValidToken.data === false) {
          window.location.reload();
        } else {
          this.correousuario = ValidToken.data;
        }
      } catch (error) {
        console.error("Error al validar token", error);
        window.location.reload();
      }
    },
    resetForm() {
      this.expense = {
        gastos: [],
        maestroGasto: null,
      };
      this.maestroGasto = [];
      this.nombregasto = '';
      this.ciudades = [];
      this.proveedores = [];
      this.conceptos = [];
      this.clientCodes = [],
      this.monedas = [];
      this.mediosPago = [];
      this.cameraAvailable = false;
      this.reloadPage();
      this.fetchProveedores();
      this.fetchCiudades();
      this.fecthConceptos();
      this.fecthClientCodes();
      this.fecthGastos();
      this.fecthCurrency();
      this.fecthPaymentMeans();
      this.expense.gastos[0].myFiles.splice(0, 1);
    },
    addGasto() {
      if (!this.expense.maestroGasto) {
        alert("No hay un gasto seleccionado");
      } else {
        this.expense.gastos.push({
          fechagasto: null,
          ciudad: null,
          proveedor: [],
          concepto: [],
          clientcode: null,
          amountofpeople: null,
          moneda: [], // Valor predeterminado
          mediopago: null,
          valor: 0.0,
          observaciones: null,
          myFiles: null,
          collapsed: false, // Estado de colapso        
          urlanexo: [],
        });
      }
      
    },
    removeGasto(index) {
      this.expense.gastos.splice(index, 1);
    },
    toggleCollapse(index) {
      this.expense.gastos[index].collapsed = !this.expense.gastos[index].collapsed;
    },
    toggleCollapseEdit(index) {
      this.gastossubidos[index].collapsed = !this.gastossubidos[index].collapsed;
    },
    async submitExpense() {
      if (!this.expense.maestroGasto || this.expense.gastos.length === 0) {
        alert("No hay datos en el formulario");
      }  else if (this.checkZeroValues() === true || this.checkRequiredFields() === true) {
        alert("Campo obligatorios sin llenar (*), revisar antes de enviar")
      } else if (this.fileUploading) {
        alert("Cargando archivo, espere.")
      } else if (this.uploading) {
        alert("Cargando gastos, espere.")
      } else {
        try {
          this.uploading = true;
          
          let dateTimeActual = new Date(Date.now());
          dateTimeActual.setHours(dateTimeActual.getHours() - 5);
          this.calcularTotalesPorMoneda();

          // Añadir el total de gastos al objeto expense
          let expenseData = {
            ...this.expense,
            totalCOP: this.totalCOP,
            totalUSD: this.totalUSD,
            fechaActualizacion: dateTimeActual.toISOString(),
          };
          // Envía los datos al servidor
        
          await updateGCS1(expenseData);
          for (const gasto of this.expense.gastos) {
              expenseData = {
                ...this.expense,
                title: 1,
                ...gasto,
                fechaCreacion: dateTimeActual.toISOString(),
                fechaActualizacion: dateTimeActual.toISOString(),
              }
              await insertarDetalleGCS(expenseData);
            }
            alert('Gastos subidos con éxito');
            this.resetForm();
          
        } catch (error) {
          console.error('Error al subir los gastos:', error);
        } finally {
          this.uploading = false;
        }
      }
    },
    checkZeroValues() {
      for (const gasto in this.expense.gastos) {
        if (this.expense.gastos[gasto].valor === 0) {
          return true
        }
      }
      return false
    },
    checkRequiredFields() {
      for (const gasto in this.expense.gastos) {
        if (
          !this.expense.gastos[gasto].fechagasto ||
          !this.expense.gastos[gasto].ciudad || 
          !this.expense.gastos[gasto].proveedor|| 
          !this.expense.gastos[gasto].concepto || 
          !this.expense.gastos[gasto].moneda || 
          !this.expense.gastos[gasto].mediopago || 
          (this.expense.gastos[gasto].concepto === 7 & 
          (!this.expense.gastos[gasto].clientcode || 
          !this.expense.gastos[gasto].amountofpeople))
        ) {
          return true
        }
      } 
        return false
      
    },
    checkRequiredEditFields() {
      for (const gasto in this.spentsedits) {
        if (
          !this.spentsedits[gasto].fechagasto ||
          !this.spentsedits[gasto].ciudad || 
          !this.spentsedits[gasto].valor || 
          !this.spentsedits[gasto].proveedor || 
          !this.spentsedits[gasto].concepto || 
          !this.spentsedits[gasto].moneda || 
          !this.spentsedits[gasto].mediopago || 
          (this.spentsedits[gasto].concepto === 7 & 
          (!this.spentsedits[gasto].cliente || 
          !this.spentsedits[gasto].amountofpeople))
        ) {
          return true
        }
      } 
        return false
      
    },
    async fetchProveedores(query = '') {
      if (query.length > 2) {
        try {
          const response = await selectProveedores(query);
          this.proveedores = response.data.map(proveedor => ({
            id: proveedor.id,
            nombreProveedor: proveedor.nombrecomercial + ' - ' + proveedor.nit + ' - ' + proveedor.razonsocial}));
        } catch (err) {
          console.error('Error obteniendo los proveedores', err);
        }
      }
    },
    onProveedorSearch(search) {
      this.fetchProveedores(search);
    },
    async fetchCiudades(query = '') {
      try {
        const cachedData = localStorage.getItem("dataCities");
        if (cachedData) {
          this.ciudades = JSON.parse(cachedData).map(ciudad => ({id: ciudad.id, nombreMunicipio: ciudad.nombreMunicipio}));
        } else {
          localStorage.removeItem("dataCities");
          if (query.length >= 0) {
            const response = await selectDepartamentos(query);
            const ciudades = response.data.map(ciudad => ({id: ciudad.codigomunicipio, nombreMunicipio: ciudad.nombredepartamento + ' - ' + ciudad.nombremunicipio}));
            // Guarda los datos en localStorage
            localStorage.setItem("dataCities", JSON.stringify(ciudades));
            this.ciudades = JSON.parse(localStorage.getItem("dataCities")).map(ciudad => ({id: ciudad.id, nombreMunicipio: ciudad.nombreMunicipio}));
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    onCiudadSearch(search) {
      this.fetchCiudades(search);
    },
    async fecthClientCodes(query) {
      try {
        const response = await selectClientCodes(query);
        this.clientCodes = response.data.map(codes => ({
          id: codes.cardcode,
          name: codes.cardcode + ' - ' + codes.nombrecomercial + ' - ' + codes.razonsocial
        }));
        
      } catch (err) {
        console.error('Error obteniendo codigos de clientes', err);
      }
    },
    onClientCodesSearch(search) {
      this.fecthClientCodes(search);
    },
    async fecthConceptos(query = '') {
      try {
        const response = await selectConceptos(query);
        this.conceptos = response.data.map(concepto => ({
          id: concepto.id,
          descripcion: concepto.descripcion
        }));
      } catch (err) {
        console.error('Error obteniendo los conceptos', err);
      }
    },
    onConceptoSearch(search) {
      this.fecthConceptos(search);
    },
    async fecthCurrency(query = '') {
      try {
        const response = await selectMonedas(query);
        this.monedas = response.data.map(moneda => ({
          id: moneda.id,
          nombreMoneda: moneda.nombremoneda
        }));
      } catch (err) {
        console.error('Error obteniendo las monedas', err);
      }
    },
    onCurrencySearch(search) {
      this.fecthCurrency(search);
    },
    async fecthPaymentMeans(query) {
      try {
        const response = await selectMediosPago(query);
        this.mediosPago = response.data.map(medioPago => ({id: medioPago.id, nombre: medioPago.nombre}));
      } catch (err) {
        console.error('Error obteniendo los medios de pago', err);
      }
    },
    onPaymentMeansSearch(search) {
      this.fecthPaymentMeans(search);
    },
    async fecthGastos(query) {
      try {
        const response = await selectMaestroGastos(query);
        this.maestroGasto = response.data.map(gasto => ({
          id: gasto.idviaje,
          nombreviaje: gasto.nombreviaje,
        }));
        if (!this.expense.maestroGasto && this.maestroGasto.length > 0) {
          this.expense.maestroGasto = this.maestroGasto[0].id;
          if (this.expense.maestroGasto) {
            this.addGasto();
          }
        }
        await this.fecthExpenses();
      } catch (err) {
        console.error('Error obteniendo los gastos', err);
        window.location.reload();
      }
    },
    onGastoSearch(search) {
      this.fecthGastos(search);
    },
    handleRemoveFile(index, fileItems) {
      try {
        if (fileItems) {
          this.expense.gastos[index].myFiles.splice(index, 1);
        } else {
          console.log('No hay nada que eliminar', fileItems);
        }
        
      } catch (error) {
        console.error(error, "Error al eliminar el archivo");
      }
      
      // Aquí puedes agregar la lógica para procesar la eliminación en el servidor o en tu sistema
    },
    onAddFileStart(file) {
    console.log("📤 Comenzando carga de archivo:", file.filename);
    this.isUploading = true;
  },
  onProcessFile(error, file) {
    if (!error) {
      console.log("✅ Archivo subido:", file.filename);
      this.isUploading = false;
    } else {
      console.error("❌ Error al subir archivo:", error);
      this.isUploading = false;
    }
  },
  async uploadFile(index, fileItems) {
    try {
      this.fileUploading = true;
      if (!fileItems || !fileItems.file) {
        console.error("No se ha subido un archivo válido", fileItems);
        return;
      }

      let file = fileItems.file;

      if (!file.name) {
        console.error("El archivo no tiene un nombre válido", file);
        return;
      }

      // Asegurar que el nombre tiene una extensión
      const nombreOriginal = file.name;
      const extension = nombreOriginal.includes(".") ? nombreOriginal.split(".").pop() : "";

      if (!extension) {
        console.error("El archivo no tiene una extensión válida", nombreOriginal);
        return;
      }

      // 🔹 Mostrar en FilePond que el archivo se está procesando
      this.expense.gastos[index].isUploading = true;

      // Si el archivo pesa más de 4MB, lo comprimimos
      if (file.size > 4 * 1024 * 1024 && extension.match(/(jpg|jpeg|png)/i)) {
        try {
          console.log("📢 Comenzando compresión...");
          const options = {
            maxSizeMB: 4, // Reducir a máximo 4MB
            useWebWorker: true,
          };
          file = await imageCompression(file, options);
          console.log("✅ Archivo comprimido:", file);
        } catch (error) {
          console.error("⚠️ Error al comprimir la imagen:", error);
        }
      }

      const nombreArchivo = `gasto_${index}_${Date.now()}.${extension}`;
      const formData = new FormData();
      formData.append("file", file, nombreArchivo);

      console.log("📌 Nombre final del archivo:", nombreArchivo);

      const nombreGasto = this.expense.maestroGasto;
      const urlAnexo = await uploadToOneDr(nombreArchivo, formData, nombreGasto);
      // 🔹 Asignar URL subida al objeto gasto
      this.expense.gastos[index].urlanexo.push(urlAnexo.data);

      // 🔹 Notificar a FilePond que la carga finalizó
      this.expense.gastos[index].isUploading = false;
      this.fileUploading = false;
    } catch (error) {
      console.error("Error al manejar el archivo:", error);
    }
  },
  onFileChange(files) { // si algo eliminar
        this.files = files;
      },
    },
  };
</script>
